import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { StockVariancesDetailDto } from './stockVariancesDetail.dto';

export class StockVariancesDto extends BaseDto {
  countedDateTime?: Date;
  countedDate?: string;
  weekNo?: number;
  monthNo?: number;
  year?: number;
  finalised?: boolean;
  merchant: MerchantDto;
  costCentreId: number;
  stockVariancesDetails?: StockVariancesDetailDto[];
}
